(function () {
  let dispose;
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const ease = value => { const t = clamp(value, 0, 1); return t * t * (3 - 2 * t); };
  function init() {
    if (dispose) dispose();
    const boy = document.querySelector('[data-pk-boy]');
    const hero = document.querySelector('.pk-us-hero[data-pk-boy-pose="hero"]');
    if (!boy || !hero) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const wide = matchMedia('(min-width: 1240px)');
    const images = new Map(Array.from(boy.querySelectorAll('[data-pose]'), image => [image.dataset.pose, image]));
    const reviews = document.querySelector('[id$="__testimonials_azQRKz"]');
    if (reviews) reviews.dataset.pkBoyPose = 'reviews';
    const created = [], entries = [];
    let frame = 0, dirty = true, points = [], mode;
    function makeSpot(pose) {
      const source = images.get(pose);
      if (!source) return null;
      const spot = document.createElement('span');
      spot.className = 'pk-boy-spot';
      spot.setAttribute('aria-hidden', 'true');
      const image = source.cloneNode(false);
      image.removeAttribute('data-pose');
      image.src = image.dataset.src;
      image.loading = 'lazy';
      spot.append(image);
      created.push(spot);
      return spot;
    }
    document.querySelectorAll('[data-pk-boy-pose]').forEach(section => {
      const pose = section.dataset.pkBoyPose;
      if (!images.has(pose)) return;
      const heading = section.querySelector('h2') || section.querySelector('.pk-assure p');
      if (!heading) return;
      const attached = pose === 'bag';
      let spot = section.querySelector('.pk-boy-spot');
      if (!spot) {
        spot = makeSpot(pose);
        if (!spot) return;
        if (pose === 'hero') heading.append(spot);
        else section.prepend(spot);
      }
      const entry = { section, pose, heading, spot, attached, previous: null };
      spot.removeAttribute('data-pk-reveal');
      spot.classList.add('pk-boy-anchor');
      if (!attached && pose !== 'hero') {
        entry.headingMark = document.createComment('');
        entry.spotMark = document.createComment('');
        heading.before(entry.headingMark);
        spot.before(entry.spotMark);
        entry.row = document.createElement('div');
        entry.row.className = 'pk-boy-heading-row';
      }
      if (pose === 'hero') heading.classList.add('pk-boy-hero-heading');
      entries.push(entry);
    });
    entries.forEach((entry, index) => {
      if (index && !entry.attached) {
        const previous = images.get(entries[index - 1].pose).cloneNode(false);
        previous.removeAttribute('data-pose');
        previous.className = 'pk-boy-previous';
        previous.loading = 'lazy';
        entry.spot.prepend(previous);
        entry.previous = previous;
      }
    });
    const parent = boy.parentNode, marker = document.createComment('');
    boy.before(marker);
    document.body.append(boy);
    boy.classList.add('pk-boy-traveller');
    function load(pose) {
      const image = images.get(pose);
      if (image && !image.getAttribute('src')) {
        image.src = image.dataset.src;
        image.addEventListener('load', schedule, { once: true, signal });
      }
      return image;
    }
    function layout() {
      const nextMode = wide.matches ? 'wide' : 'compact';
      if (mode !== nextMode) {
        mode = nextMode;
        document.documentElement.dataset.pkBoyLayout = mode;
        entries.forEach(entry => {
          entry.spot.style.cssText = '';
          if (!entry.row) return;
          if (mode === 'compact') {
            entry.headingMark.after(entry.row);
            entry.row.append(entry.heading, entry.spot);
          } else {
            entry.headingMark.after(entry.heading);
            entry.spotMark.after(entry.spot);
            entry.row.remove();
          }
        });
      }
      entries.forEach(entry => { if (!entry.attached) entry.spot.style.transform = 'none'; });
      const scroll = window.scrollY;
      points = entries.map(entry => {
        const h = entry.heading.getBoundingClientRect();
        const section = entry.pose === 'hero' ? entry.section.closest('.shopify-section') || entry.heading.closest('section') : entry.section;
        const s = section.getBoundingClientRect();
        if (entry.attached || mode === 'compact') {
          const r = entry.spot.getBoundingClientRect();
          return { x:r.left, y:r.top + scroll, width:r.width, height:r.height, bottom:s.bottom + scroll, entry };
        }
        const wrap = entry.section.querySelector('.pk-wrap, .page-width');
        const contentRight = wrap ? wrap.getBoundingClientRect().right - parseFloat(getComputedStyle(wrap).paddingRight) : h.right;
        const width = clamp(s.right - contentRight - 32, 56, 128);
        const x = Math.min(s.right - width - 12, contentRight + 16);
        const y = Math.max(s.top + 12, h.top + (h.height - width * 1.5) / 2) + scroll;
        const point = {x, y, width, height:width * 1.5, bottom:s.bottom + scroll, entry};
        const container = entry.pose === 'hero' ? h : s;
        entry.spot.style.left = (x - container.left) + 'px';
        entry.spot.style.top = (y - scroll - container.top) + 'px';
        entry.spot.style.width = width + 'px';
        entry.spot.style.height = width * 1.5 + 'px';
        return point;
      });
      dirty = false;
    }
    function position(point, scroll) {
      const natural = point.y - scroll;
      if (point.entry.attached) return natural;
      return clamp(innerHeight * .38, natural, Math.max(natural, point.bottom - scroll - point.height - 20));
    }
    function update() {
      frame = 0;
      if (dirty) layout();
      if (!points.length) return;
      const scroll = window.scrollY, vh = innerHeight;
      const finalPoint = points[points.length - 1];
      if (finalPoint.entry.attached) {
        const rect = finalPoint.entry.spot.getBoundingClientRect();
        Object.assign(finalPoint, {x:rect.left, y:rect.top + scroll, width:rect.width, height:rect.height});
      }
      const moving = mode === 'wide' && !reduced.matches;
      document.documentElement.classList.toggle('pk-boy-travelling', moving);
      if (!moving) {
        boy.style.opacity = '0';
        points.forEach(point => {
          const {entry} = point;
          if (entry.attached) { entry.spot.style.opacity = '1'; return; }
          const t = reduced.matches ? 1 : ease((vh * .9 - (point.y - scroll)) / (vh * .3));
          const incoming = entry.spot.querySelector('img:not(.pk-boy-previous)');
          incoming.style.opacity = String(entry.previous ? t : 1);
          if (entry.previous) {
            entry.previous.style.opacity = String(1 - t);
            if (point.y - scroll < vh * 1.3 && !entry.previous.getAttribute('src')) entry.previous.src = entry.previous.dataset.src;
          }
          entry.spot.style.transform = reduced.matches ? 'none' : 'translate3d(0,' + ((1 - t) * 10).toFixed(2) + 'px,0) scale(' + (.96 + .04 * t).toFixed(4) + ')';
        });
        return;
      }
      let index = 0;
      for (let i = 1; i < points.length; i++) {
        if (scroll >= points[i].y - vh * .42) index = i;
      }
      const a = points[index], b = points[Math.min(index + 1, points.length - 1)];
      const start = Math.max(a.y - vh * .42, b.y - vh * .88);
      const end = b.y - vh * .42;
      const t = a === b ? 0 : ease((scroll - start) / Math.max(1, end - start));
      load(a.entry.pose);
      const incoming = load(b.entry.pose);
      if (points[index + 2]) load(points[index + 2].entry.pose);
      const ready = incoming && incoming.complete && incoming.naturalWidth > 0;
      const blend = ready ? t : 0;
      images.forEach((image, pose) => {
        image.style.opacity = String(pose === a.entry.pose ? 1 - blend : pose === b.entry.pose ? blend : 0);
      });
      const horizontal = b.entry.attached ? ease((t - .45) / .55) : t;
      const vertical = b.entry.attached ? ease(t / .45) : t;
      const x = a.x + (b.x - a.x) * horizontal;
      const y = position(a, scroll) + (position(b, scroll) - position(a, scroll)) * vertical;
      const width = a.width + (b.width - a.width) * (b.entry.attached ? vertical : t);
      boy.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) scale(' + (width / 100).toFixed(4) + ')';
      const final = points[points.length - 1];
      const docked = a.entry.attached;
      final.entry.spot.style.opacity = docked ? '1' : '0';
      boy.style.opacity = docked || y > vh || y + width * 1.5 < 0 ? '0' : '1';
    }
    function schedule() { if (reduced.matches && !dirty) return; if (!frame) frame = requestAnimationFrame(update); }
    function measure() { dirty = true; schedule(); }
    window.addEventListener('scroll', schedule, { passive:true, signal });
    window.addEventListener('resize', measure, { passive:true, signal });
    window.addEventListener('load', measure, { once:true, signal });
    reduced.addEventListener('change', measure, { signal });
    wide.addEventListener('change', measure, { signal });
    document.addEventListener('toggle', measure, { capture:true, signal });
    document.addEventListener('transitionend', event => {
      if (event.target.matches('[data-pk-reveal]')) measure();
    }, { capture:true, signal });
    const observer = new ResizeObserver(measure);
    entries.forEach(entry => observer.observe(entry.section === hero ? hero.closest('.product') : entry.section));
    document.fonts.ready.then(() => { if (!signal.aborted) measure(); });
    dispose = () => {
      controller.abort();
      observer.disconnect();
      cancelAnimationFrame(frame);
      entries.forEach(entry => {
        if (entry.row) {
          entry.headingMark.after(entry.heading);
          entry.spotMark.after(entry.spot);
          entry.row.remove(); entry.headingMark.remove(); entry.spotMark.remove();
        }
        entry.previous?.remove();
        entry.spot.style.cssText = '';
        entry.heading.classList.remove('pk-boy-hero-heading');
      });
      created.forEach(node => node.remove());
      if (marker.isConnected) marker.replaceWith(boy);
      else parent.append(boy);
      document.documentElement.classList.remove('pk-boy-travelling');
      delete document.documentElement.dataset.pkBoyLayout;
    };
    update();
  }
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();